import React from "react";
import styled from "styled-components";
import { ToolbarItem } from "../../components/Toolbar";
import {
  MdZoomIn,
  MdZoomOut,
  MdLayersClear,
  MdCenterFocusStrong,
  MdHome,
  MdFlip,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { getZoom } from "../../reducers/project/selectors";
import { ProjectActions } from "../../reducers/project/actionsNames";
import content from "../../content";
import { Desktop, Mobile, useMobile } from "../../components/Responsive";

const Wrapper = styled.div<{ mobile: boolean }>`
  display: flex;
  flex-direction: column;
  position: absolute;
  transform: translate(16px, 0);
  z-index: 30000;
  top: ${({mobile}) => mobile?'40%':'50%'};
`;

function Toolbar({}: IToolbar) {
  const zoom = useSelector(getZoom);

  const dispatch = useDispatch();

  const mobile = useMobile();

  const handleZoom = (z: number) => () => {
    if ((z === -1 && zoom > 1) || (z === 1 && zoom <= 4)) {
      dispatch({ type: ProjectActions.SetZoom, zoom: zoom + z });
    }
  };

  const resetZoom = () => dispatch({ type: ProjectActions.SetZoom, zoom: 1 });
  const toggleFlip = () => dispatch({ type: ProjectActions.ToggleFlip });

  const center = () => dispatch({ type: ProjectActions.Center });

  const changeWall = () => dispatch({ type: ProjectActions.ChangeWall });

  return (
    <Wrapper mobile={mobile}>
      <Mobile>
        <ToolbarItem
          label={zoom * 100 + "%"}
          labelSpacing={true}
          Icon={
            <svg
              onClick={handleZoom(1)}
              width="14"
              height="13"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.29999 4.52878H7.69999C8.08639 4.52878 8.4 4.82069 8.4 5.18038C8.4 5.54008 8.08639 5.83201 7.69999 5.83201H6.29999V7.13524C6.29999 7.49494 5.9864 7.78687 5.6 7.78687C5.2136 7.78687 4.9 7.49494 4.9 7.13524V5.83201H3.5C3.1136 5.83201 2.80001 5.54008 2.80001 5.18038C2.80001 4.82069 3.1136 4.52878 3.5 4.52878H4.9V3.22552C4.9 2.86583 5.2136 2.5739 5.6 2.5739C5.9864 2.5739 6.29999 2.86583 6.29999 3.22552V4.52878ZM13.7949 12.8089C13.5219 13.0637 13.0781 13.0637 12.8051 12.8089L10.0401 10.235L11.0299 9.31362L13.7949 11.8875C14.0686 12.1416 14.0686 12.5548 13.7949 12.8089ZM5.6 9.12269C3.2844 9.12269 1.4 7.36919 1.4 5.21297C1.4 3.05741 3.2844 1.30323 5.6 1.30323C7.9156 1.30323 9.79999 3.05741 9.79999 5.21297C9.79999 7.36919 7.9156 9.12269 5.6 9.12269ZM5.6 0C2.5074 0 0 2.33411 0 5.21297C0 8.09249 2.5074 10.4259 5.6 10.4259C8.69259 10.4259 11.2 8.09249 11.2 5.21297C11.2 2.33411 8.69259 0 5.6 0Z"
                fill="#C41230"
              />
            </svg>
          }
        />
        <ToolbarItem
          label={zoom * 100 + "%"}
          labelSpacing={true}
          Icon={
            <svg
              onClick={handleZoom(-1)}
              width="14"
              height="13"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.86891 5.83209H8.60674V4.52881H2.86891V5.83209ZM13.9286 12.0786L12.9137 13L9.87121 10.2351L10.8854 9.31374L13.9286 12.0786ZM5.73783 9.12281C3.36452 9.12281 1.43446 7.36927 1.43446 5.21303C1.43446 3.05744 3.36452 1.30325 5.73783 1.30325C8.11042 1.30325 10.0412 3.05744 10.0412 5.21303C10.0412 7.36927 8.11042 9.12281 5.73783 9.12281ZM5.73783 0C2.56839 0 0 2.33414 0 5.21303C0 8.09193 2.56839 10.4261 5.73783 10.4261C8.90654 10.4261 11.4757 8.09193 11.4757 5.21303C11.4757 2.33414 8.90654 0 5.73783 0Z"
                fill="#C41230"
              />
            </svg>
          }
        />
      </Mobile>
      <Desktop>
        <ToolbarItem
          AfterIcon={
            <svg
              onClick={handleZoom(1)}
              width="14"
              height="13"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.29999 4.52878H7.69999C8.08639 4.52878 8.4 4.82069 8.4 5.18038C8.4 5.54008 8.08639 5.83201 7.69999 5.83201H6.29999V7.13524C6.29999 7.49494 5.9864 7.78687 5.6 7.78687C5.2136 7.78687 4.9 7.49494 4.9 7.13524V5.83201H3.5C3.1136 5.83201 2.80001 5.54008 2.80001 5.18038C2.80001 4.82069 3.1136 4.52878 3.5 4.52878H4.9V3.22552C4.9 2.86583 5.2136 2.5739 5.6 2.5739C5.9864 2.5739 6.29999 2.86583 6.29999 3.22552V4.52878ZM13.7949 12.8089C13.5219 13.0637 13.0781 13.0637 12.8051 12.8089L10.0401 10.235L11.0299 9.31362L13.7949 11.8875C14.0686 12.1416 14.0686 12.5548 13.7949 12.8089ZM5.6 9.12269C3.2844 9.12269 1.4 7.36919 1.4 5.21297C1.4 3.05741 3.2844 1.30323 5.6 1.30323C7.9156 1.30323 9.79999 3.05741 9.79999 5.21297C9.79999 7.36919 7.9156 9.12269 5.6 9.12269ZM5.6 0C2.5074 0 0 2.33411 0 5.21297C0 8.09249 2.5074 10.4259 5.6 10.4259C8.69259 10.4259 11.2 8.09249 11.2 5.21297C11.2 2.33411 8.69259 0 5.6 0Z"
                fill="#C41230"
              />
            </svg>
          }
          label={zoom * 100 + "%"}
          labelSpacing={true}
          Icon={
            <svg
              onClick={handleZoom(-1)}
              width="14"
              height="13"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.86891 5.83209H8.60674V4.52881H2.86891V5.83209ZM13.9286 12.0786L12.9137 13L9.87121 10.2351L10.8854 9.31374L13.9286 12.0786ZM5.73783 9.12281C3.36452 9.12281 1.43446 7.36927 1.43446 5.21303C1.43446 3.05744 3.36452 1.30325 5.73783 1.30325C8.11042 1.30325 10.0412 3.05744 10.0412 5.21303C10.0412 7.36927 8.11042 9.12281 5.73783 9.12281ZM5.73783 0C2.56839 0 0 2.33414 0 5.21303C0 8.09193 2.56839 10.4261 5.73783 10.4261C8.90654 10.4261 11.4757 8.09193 11.4757 5.21303C11.4757 2.33414 8.90654 0 5.73783 0Z"
                fill="#C41230"
              />
            </svg>
          }
        />
      </Desktop>
      <ToolbarItem
        onClick={center}
        Icon={
          <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.6 5.85H9.8V7.15H12.6V11.7H7.7V9.1H6.3V11.7H1.4V7.15H4.2V5.85H1.4V1.3H6.3V3.9H7.7V1.3H12.6V5.85ZM0 13H14V0H0V13Z"
              fill="#C41230"
            />
          </svg>
        }
        label={content.getValue("toolbar_center")}
      />
      <ToolbarItem
        onClick={toggleFlip}
        Icon={
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="4.6"
              y="0.6"
              width="6.8"
              height="11.8"
              stroke="#C41230"
              stroke-width="1.2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.29762 2.60992L0.178787 1.97272C0.0355128 2.4759 -0.0250413 3.00323 0.0094728 3.53411C0.214272 6.68263 3.20897 8.68399 6.2042 7.88142L6.51691 9.04847L9.04307 6.49532L5.57877 5.54731L5.89149 6.71436C3.4953 7.35642 1.362 5.78784 1.24377 3.39852C1.23068 3.13286 1.24959 2.86842 1.29762 2.60992Z"
              fill="#C41230"
            />
          </svg>
        }
        label={content.getValue("toolbar_flip")}
      />
      <ToolbarItem
        onClick={resetZoom}
        Icon={
          <svg
            width="13"
            height="15"
            viewBox="0 0 13 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3279 10.1065C10.3163 12.4422 7.43 13.5949 4.88597 12.3232C3.27063 11.5153 2.24204 9.79744 2.32875 8.03713C2.47767 5.02751 5.16481 3.05171 8.18307 3.86045L7.78917 5.33049L12.1528 4.13636L8.97086 0.920376L8.57696 2.39041C4.80414 1.37949 1.03198 3.90042 0.774017 7.86634C0.617007 10.2814 2.02192 12.6382 4.25606 13.7142C7.64209 15.3447 11.4385 13.8049 12.7694 10.7031C12.9501 10.282 12.6916 9.79525 12.2381 9.67373L12.2388 9.67393C11.8638 9.57344 11.4784 9.75921 11.3279 10.1065Z"
              fill="#C41230"
            />
          </svg>
        }
        label={content.getValue("toolbar_reset")}
      />
      <ToolbarItem
        onClick={changeWall}
        Icon={<MdHome style={{ fontSize: "16px" }} />}
        label={content.getValue("toolbar_wallpaper")}
      />
    </Wrapper>
  );
}

export interface IToolbar {}

export default Toolbar;
